import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'icon' | 'outline';
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  disabled?: boolean;
  title?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'secondary',
  onClick,
  type = 'button',
  className = '',
  disabled = false,
  title,
}) => {
  const getVariantClasses = () => {
    switch (variant) {
      case 'primary':
        return 'bg-primary-700 text-white hover:bg-primary-800 hover:scale-102 dark:bg-primary-600 dark:hover:bg-primary-500';
      case 'secondary':
        return 'bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 border border-solid border-gray-300 dark:border-slate-600 hover:bg-gray-50 dark:hover:bg-slate-600';
      case 'outline':
        return 'bg-transparent border border-solid border-primary-600 dark:border-primary-500 text-primary-700 dark:text-primary-300 hover:bg-primary hover:text-white dark:hover:bg-primary-600 dark:hover:text-white';
      case 'icon':
        return 'bg-transparent border-0 p-2 text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100';
      default:
        return 'bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200';
    }
  };

  const baseClasses = 'inline-block px-6 py-3 font-bold text-center uppercase align-middle transition-all ease-in rounded-lg select-none leading-pro text-xs';
  
  return (
    <button
      type={type}
      className={`${baseClasses} ${getVariantClasses()} ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      {children}
    </button>
  );
};

export default Button;
